import {
  subCampProductDetail
} from '@/api/sys/subCampProduct'
export default {
  namespaced: true,
  actions: {
    subCampProductDetail({
      dispatch
    }, {
      vm,
      subCampProductBizRecId
    }) {
      subCampProductDetail(subCampProductBizRecId)
        .then(res => {
          vm.loading.close()
          vm.tableDataList = res.data
        })
        .catch(err => {
          vm.loading.close()
          vm.$alert('缺少参数，请重新打开', '操作提示', {
            confirmButtonText: '确定'
          })
        })
    }

  }
}